import React from 'react';
import ReactDOM from 'react-dom/client';
import './init.scss';
import '@saif/mosaic/scss/all.scss';
import './index.css';
import './brand.css';
import './i18n';
import App from './Views/App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
